import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import dayjs from "dayjs";

export default function Inbox() {
  const [vol, setVol] = useState([]);
  const [ret, setRet] = useState([]);
  const [msg, setMsg] = useState([]);
  const [dub, setDub] = useState([]);
  useEffect(() => {
    api.get("/admin/volunteer-applications").then(r => setVol(r.data));
    api.get("/admin/retreat-applications").then(r => setRet(r.data));
    api.get("/admin/messages").then(r => setMsg(r.data));
    api.get("/admin/dubbi-interests").then(r => setDub(r.data));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="overline">Applications & Messages</div>
        <h1 className="font-serif text-4xl mt-1">Inbox</h1>
      </div>
      <Tabs defaultValue="volunteers">
        <TabsList>
          <TabsTrigger value="volunteers" data-testid="inbox-tab-volunteers">Volunteers ({vol.length})</TabsTrigger>
          <TabsTrigger value="retreats" data-testid="inbox-tab-retreats">Retreats ({ret.length})</TabsTrigger>
          <TabsTrigger value="messages" data-testid="inbox-tab-messages">Messages ({msg.length})</TabsTrigger>
          <TabsTrigger value="dubbi" data-testid="inbox-tab-dubbi">Dubbi ({dub.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="volunteers"><List items={vol} kind="volunteer" /></TabsContent>
        <TabsContent value="retreats"><List items={ret} kind="retreat" /></TabsContent>
        <TabsContent value="messages"><List items={msg} kind="message" /></TabsContent>
        <TabsContent value="dubbi"><List items={dub} kind="dubbi" /></TabsContent>
      </Tabs>
    </div>
  );
}

function List({ items, kind }) {
  if (!items.length) return <div className="text-ink-soft py-16 text-center">Nothing here yet.</div>;
  return (
    <div className="space-y-3 mt-4">
      {items.map((x) => (
        <div key={x.id} className="bg-admin-surface border border-line rounded-xl p-5" data-testid={`inbox-${kind}-${x.id}`}>
          <div className="flex items-center justify-between">
            <div>
              <div className="font-medium">{x.name}</div>
              <div className="text-xs text-ink-soft">{x.email} {x.country ? `· ${x.country}` : ""}</div>
            </div>
            <div className="text-xs text-ink-soft">{dayjs(x.created_at).format("MMM D, YYYY")}</div>
          </div>
          {kind === "volunteer" && <div className="mt-3 grid md:grid-cols-2 gap-3 text-sm">
            <Field label="Skills" val={x.skills} /><Field label="Availability" val={x.availability} />
            <Field label="Languages" val={x.languages} /><Field label="Interests" val={x.interests} />
          </div>}
          {kind === "retreat" && <div className="mt-3 grid md:grid-cols-2 gap-3 text-sm">
            <Field label="Retreat" val={x.retreat_title} /><Field label="Intentions" val={x.intentions} />
            <Field label="Dietary" val={x.dietary} /><Field label="Medical" val={x.medical} />
          </div>}
          {kind === "message" && <div className="mt-3 text-sm text-ink-soft"><Field label={x.subject || "Message"} val={x.message} /></div>}
          {kind === "dubbi" && <div className="mt-3 text-sm">
            <Field label={`Type: ${x.interest_type}`} val={x.message} />
            {x.budget && <div className="text-ink-soft mt-1">Budget: {x.budget}</div>}
          </div>}
        </div>
      ))}
    </div>
  );
}

function Field({ label, val }) {
  if (!val) return null;
  return <div><div className="overline">{label}</div><div className="text-ink mt-1">{val}</div></div>;
}
